module.exports = __webpack_public_path__ + "static/media/nodeJS.a31b1671.png";